import {combineReducers} from 'redux';
import {reducer as form} from 'redux-form';

import xl from './xl';
import auth from './auth';
import serverInfo from './serverInfo';

const rootReducer = combineReducers({xl, auth, serverInfo, form});

export default rootReducer;



// WEBPACK FOOTER //
// ./reducers/index.js